import { render } from "./HeaderResults.vue?vue&type=template&id=44295dc2&scoped=true"
import script from "./HeaderResults.vue?vue&type=script&lang=js"
export * from "./HeaderResults.vue?vue&type=script&lang=js"

import "./HeaderResults.vue?vue&type=style&index=0&id=44295dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44295dc2"]])

export default __exports__